package org.example.project.enginevertrieb

import org.example.project.utils.All

/** Immediate UI projection; the saved server response remains authoritative. */
internal fun optimisticLinkedInCheckpoint(lead: All, action: String, result: String, note: String): All {
    val at = kotlin.js.Date().toISOString()
    val target = when (action) {
        "DM_SENT" -> if (lead.vertriebCheckpoint == "MY_LEADS") "CONTACTED" else lead.vertriebCheckpoint
        "FOLLOWUP", "REMINDER", "ABORT" -> lead.vertriebCheckpoint
        "CALL_COMPLETED" -> if (lead.vertriebCheckpoint in setOf("MY_LEADS", "CONTACTED")) "REPLIED" else lead.vertriebCheckpoint
        else -> action
    }
    val updated = lead.copy(
        vertriebCheckpoint = target,
        vertriebCheckpointAm = if (target != lead.vertriebCheckpoint) at else lead.vertriebCheckpointAm,
        vertriebMeilensteine = lead.vertriebMeilensteine + (target to at),
        vertriebLetzteAktionAm = at,
        vertriebFollowUpFaellig = false,
        vertriebFollowUpAm = "",
        linkedinAntwortErhalten = lead.linkedinAntwortErhalten || target == "REPLIED",
        linkedinAngeschrieben = lead.linkedinAngeschrieben || action == "DM_SENT",
        linkedinMaterialAngefragt = lead.linkedinMaterialAngefragt || action == "MATERIAL_REQUESTED",
        linkedinMaterialGesendet = lead.linkedinMaterialGesendet || action == "MATERIAL_SENT"
    )
    return if (action == "CLOSED") updated.copy(
        vertriebAbschlussErgebnis = result, vertriebAbschlussGrund = note,
        linkedinAbschlussErgebnis = if (result == "Gewonnen") "Positiv" else "Negativ",
        linkedinAbschlussNotiz = note, linkedinAbschlussAm = at,
        linkedinGeschlossen = true, akquiseAbschlussAm = at, akquiseAbschlussNotiz = note,
        akquiseErgebnis = if (result == "Gewonnen") "Positiv" else "Negativ"
    ) else updated
}
